import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";

import { titleModal } from "App/utils/helpers";
import { Grid } from "@material-ui/core";

export const RESET_TAB_MODAL = {
  id: "",
  item_id: "",
  name: "",
  qty: 1,
};

export const ModalForm = ({
  setShowModal,
  form,
  setForm,
  handleSubmit,
  disabled,
}) => {
  const handleChange = (text) => (e) => {
    setForm({
      ...form,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={`${titleModal(form.id)}`} show={setShowModal}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='NAMA'
              id='name'
              value={form.name}
              readOnly
              disabled
              placeholder='Nama'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='qty'
              label='QTY'
              id='qty'
              value={form.qty}
              onChange={handleChange("qty")}
              placeholder='Qty'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='button'
            onClick={handleSubmit}
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
